/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import {useTranslation} from "react-i18next";
import {useRegion} from "../../context/RegionContext";
import React from "react";
import region_global_svg from "../../static/img/header/ic-region-global.svg";
import region_china_svg from "../../static/img/header/ic-region-china.svg";

const HeaderUtilLocationComponent = ({subMenu, setSubMenu}) => {
    const {t} = useTranslation();
    const {region} = useRegion();

    return (
        <>
            <li className="section">
                <div className="section-head">{t('@Region@')}</div>
                <div className="section-items selection" onClick={()=>setSubMenu('region')} data-option="region">
                    <div className="section-items__group">
                        <div className="w-18px mr-8"><img src={region === 'GLOBAL' ? region_global_svg : region_china_svg} alt={region}/></div>
                        <div className="select-label">{region === 'GLOBAL' ? t('@Global@') : t('@China@')}</div>
                        <div className="select-ic"></div>
                    </div>
                </div>
            </li>
        </>
    );
};

export default HeaderUtilLocationComponent;